import * as Types from '../../../../../graphql.generated';

export type SocialSignInFacebookMutationVariables = Types.Exact<{
    accessToken: Types.Scalars['String'];
}>;

export type SocialSignInFacebookMutation = { __typename?: 'Mutation' } & {
    socialSignInFacebook?: Types.Maybe<
        { __typename?: 'SocialSignInFacebookResponse' } & Pick<
            Types.SocialSignInFacebookResponse,
            'success'
        >
    >;
};

export const SocialSignInFacebookDocument = `
    mutation socialSignInFacebook($accessToken: String!) {
  socialSignInFacebook(accessToken: $accessToken) {
    success
  }
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        socialSignInFacebook(
            variables: SocialSignInFacebookMutationVariables,
            options?: C
        ): Promise<SocialSignInFacebookMutation> {
            return requester<
                SocialSignInFacebookMutation,
                SocialSignInFacebookMutationVariables
            >(SocialSignInFacebookDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
